<template>
    <div style="height: 100%;">
      <my-header :left-click="back">
        体侧屈
      </my-header>
      <video ref="input_video" width="100%" height="100%" style="display: none;"></video>
      <div style="position: relative;">
        <div style="position: absolute; display: block; text-align: right; float: right; width: 100%;">
          <van-image :src="stopImage"  width="50" height="50" @click="over"></van-image>
        </div>
        <canvas
            class="output_canvas"
            ref="output_canvas"
            :width="width"
            :height="height"
        />
      </div>
      <van-popup v-model="overShow" title="标题" style="width: 100%; height: 100%;">
        <div class="over-popup" :style="{backgroundImage:`url(${overImage})`}">
          <p class="counter">{{ this.squats.counter }}个</p>
          <van-button class="over-button" size="large" type="info" round @click="back">结束运动</van-button>
        </div>
      </van-popup>
    </div>
</template>
<script>
import { Pose, POSE_CONNECTIONS } from "@mediapipe/pose";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { Field, Button, Toast, Cell, CellGroup, Row, Col, Popup, Icon, Image as VanImage, Dialog } from 'vant'
import { checkBodyFlexion } from '@/utils/mediapipe'

export default {
  name: "BodyFlexionModel",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Button.name]: Button
  },
  data: function() {
    return {
      camera: null,
      number: null,
      ctx: null,
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      overShow: false,
      timeout: 3,
      waiting: false,
      timer: null,
      rightCount: 0,
      leftCount: 0,
      handsImage: '',
      squats: {
        threshold: 0,
        count: 0,
        direction: '', // 移动方向
        upCount: 0,
        downCount: 0,
        counter: 0
      },
      stopImage: require('@/assets/css/stop.png'),
      overImage: require('@/assets/css/over.png')
    };
  },
  computed: {
    inputVideo() {
      return this.$refs.input_video;
    },
  },
  mounted() {
    this.ctx = this.$refs.output_canvas.getContext("2d");
    this.init();
  },
  methods: {
    init() {
      this.handsImage = new Image();
      this.handsImage.src = require('@/assets/hands.png');
      window.requestAnimationFrame(this.pose);
    },
    pose() {
      const pose = new Pose({
        locateFile: (file) => {
          console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/pose@0.5.1635988162/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5.1635988162/${file}`;
        },
      });
      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        enableSegmentation: true,
        smoothSegmentation: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });
      pose.onResults(this.onResults);

      this.camera = new Camera(this.inputVideo, {
        onFrame: async () => {
          await pose.send({ image: this.inputVideo });
        },
        facingMode: this.$store.getters.facingMode,
        width: this.$store.getters.cameraRP.width,
      });
      this.camera.start();
    },
    calcDistance(p1, p2) {
      const distance = Math.sqrt(Math.abs(Math.pow(p1['x'] - p2['x'], 2))
          + Math.abs(Math.pow(p1['y'] - p2['y'], 2))
          + Math.abs(Math.pow(p1['z'] - p2['z'], 2)))
      return distance
    },
    onResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;
      this.ctx.save();
      this.ctx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.ctx.translate(results.image.width, 0);
      this.ctx.scale(-1, 1);
      // console.log(results.image)
      this.ctx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );
      // this.findHands(results);

      if (results.poseLandmarks) {

        checkBodyFlexion(results.poseWorldLandmarks, this.squats.threshold).then(res => {
          // switch (this.squats.threshold) {
          //   case 0:
          //     this.squats.threshold = 1
          //     break;
          //   case 1:
          //     console.log(this.squats.threshold)
          //     this.squats.threshold = 0
          //     this.squats.counter++
          //     break;
          //   default:
          //     break;
          // }
          if(this.squats.threshold === 0){
            this.squats.counter = this.squats.counter + 0.5
            this.squats.threshold = 1
          }else if(this.squats.threshold === 1){
            this.squats.counter = this.squats.counter + 0.5
            this.squats.threshold = 0
          }
        }).catch(err => {
          console.log(err)
        })
        // console.log('cos' + cos25)
        // console.log('agent' + agent)

        // for (const landmarks of results.poseLandmarks) {
          drawConnectors(this.ctx, results.poseLandmarks, POSE_CONNECTIONS, {
            color: "#00FF00",
            lineWidth: 4,
          });
          drawLandmarks(this.ctx, results.poseLandmarks, {
            color: "#FF0000",
            lineWidth: 2,
          })
        // }
      }
      this.ctx.restore();
      this.ctx.font = '50px STheiti, SimHei';
      this.ctx.fillStyle = "green"
      this.ctx.fillText(this.squats.counter, 30, 100, 200)
    },
    findHands(results, draw = true) {
      if (results.multiHandLandmarks) {
        for (const landmarks of results.multiHandLandmarks) {
          drawConnectors(this.ctx, landmarks, POSE_CONNECTIONS, {
            color: "#00FF00",
            lineWidth: 5,
          });
          if (draw) {
            drawLandmarks(this.ctx, landmarks, {
              color: "#FF0000",
              lineWidth: 2,
            })
          }
        }
      }
    },
    checkHandsPosition(position){
      if(position.x < 0.5) {
        this.rightCount++
        this.leftCount = 0
        if(this.rightCount > 50){
          Toast('答对了')
          this.rightCount = 0
        }
      }else{
        this.leftCount++
        this.rightCount = 0
        if(this.leftCount > 50){
          Toast('答错了')
          this.leftCount = 0
        }
      }
      // if(!this.timer) {
      //   this.timer = setInterval(()=>{
      //     this.timeout--
      //     if(this.timeout <= 0){
      //       clearInterval(this.timer)
      //       this.timer = null
      //     }
      //   }, 1000);
      // }
      console.log(position)
    },
    over() {
      Dialog.confirm({
        title: '训练确认',
        message: '是否结束训练',
      }).then(()=>{
        this.overShow = true
      })
    },
    back() {
      this.$router.push({ path: '/exercise/types', query: { type: 0 } })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.camera.stop()
    next()
  }
}
</script>

<style scoped>
.output_canvas {
  width: 100%;
  height: 100%;
}
.title{
  font-size: 3rem;
  font-weight: bold;
  text-align: left;
  margin-left: 20px;
}
.counter{
  margin-top: 100%;
  font-size: 3rem;
  font-weight: bold;
  color: #194ea7;
}
.over-popup{
  position: absolute;
  width: 100%;
  text-align: center;
  background-size: 100%;
  background-repeat: no-repeat;
  height: 100%;
}
.over-button{
  font-size: 2rem;
  font-weight: bold;
  width: 50%;
}
</style>
